<div class="kt-margin-b-25" style="min-width: 700px;">
    <div class="row">
        <div class="col-12">
            <canvas #epiChart></canvas>
        </div>
    </div>
</div>